var _excluded = ["header", "headerHasNoTitle", "content", "width", "buttons", "isLoading", "hasAnimationOnClose", "handleCloseButtonClick"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useEffect, useRef } from "react";
import { preventDefault } from "../../../../helpers/PreventPageScroll";
import useClickOutside from "../../../../hooks/useClickOutside";
import useEscClick from "../../../../hooks/useEscClick";
import useModalFocus from "../../../../hooks/useModalFocus";
import PortalContainerOrg, { PortalType } from "../../../organisms/PortalContainerOrg";
import SurfaceOrg from "../../../organisms/SurfaceOrg";
import { defaultProps } from "./ModalOrg.props";
import { surfaceColorVariant } from "./ModalOrg.settings";
import { Buttons, Container, Content, ContentWrapper, Header, IconContainer, LoaderIcon, Overlay } from "./ModalOrg.styled";
function ModalOrg(_ref) {
  var header = _ref.header,
    headerHasNoTitle = _ref.headerHasNoTitle,
    content = _ref.content,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? defaultProps.width : _ref$width,
    buttons = _ref.buttons,
    isLoading = _ref.isLoading,
    hasAnimationOnClose = _ref.hasAnimationOnClose,
    handleCloseButtonClick = _ref.handleCloseButtonClick,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var containerRef = useRef(null);
  var overlayRef = useRef(null);
  var _useModalFocus = useModalFocus(containerRef),
    handleKeyDown = _useModalFocus.handleKeyDown;
  useClickOutside(containerRef, handleCloseButtonClick);
  useEscClick(containerRef, handleCloseButtonClick);
  useEffect(function () {
    var overlay = overlayRef.current;
    if (overlay) {
      overlay.addEventListener("touchmove", preventDefault, {
        passive: false
      });
    }
    return function () {
      if (overlay) {
        overlay.removeEventListener("touchmove", preventDefault);
      }
    };
  }, [overlayRef]);
  return /*#__PURE__*/React.createElement(PortalContainerOrg, {
    portalType: PortalType.MODAL
  }, /*#__PURE__*/React.createElement(Overlay, _extends({
    ref: overlayRef
  }, restProps), /*#__PURE__*/React.createElement(Container, {
    ref: containerRef,
    onKeyDown: handleKeyDown,
    $width: width,
    $isLoading: !!isLoading,
    $hasContent: !!content,
    $hasAnimationOnClose: hasAnimationOnClose
  }, /*#__PURE__*/React.createElement(SurfaceOrg, {
    spacingSpace: 0,
    color: surfaceColorVariant,
    shadow: "large"
  }, /*#__PURE__*/React.createElement(ContentWrapper, null, header ? /*#__PURE__*/React.createElement(Header, {
    $hasNoTitle: !!headerHasNoTitle
  }, header) : null, isLoading ? /*#__PURE__*/React.createElement(IconContainer, null, /*#__PURE__*/React.createElement(LoaderIcon, null)) : /*#__PURE__*/React.createElement(Content, {
    $hasNoTitle: !!headerHasNoTitle
  }, content), !isLoading ? /*#__PURE__*/React.createElement(Buttons, null, buttons) : null)))));
}
export default ModalOrg;